// extracted by mini-css-extract-plugin
export default {"divider":"courseTopics_divider__yLYwy","title":"courseTopics_title__ZKQkf","container":"courseTopics_container__e4gXZ"};